<template>
<div id="home">
  <header id="hero">
    <AppNavigation />
      <LandingPage />
  </header>
  <main >
    <About />
  </main>
  <Footer />
</div>

</template>

<script>
import AppNavigation from '../components/AppNavigation'
import LandingPage from '../views/LandingPage'
import Footer from '../components/Footer'
import About from './About'
export default {
 components: {
     AppNavigation,
     LandingPage,
     Footer,
     About
 }
}
</script>

<style scoped>
#hero{
  width:100%;
  height:100%;
  position: relative;
  background-size: cover;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
    background-size: cover;
  color:#fff;
  background: #192440 ;
  background: url("../assets/background/banner-bk.jpg") no-repeat center center fixed; 
}
</style>